// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"47":"pricing","163":"map","920":"forbussines"}[chunkId] + "." + {"47":"399f31dd","163":"66472762","920":"a344d968"}[chunkId] + ".js";
};